module.exports = __webpack_public_path__ + "media/site_templates/www.mulchingservices.net.au/images/splash-2487a8d8178f2cdf9b17ae0d70b29e51.jpg";